import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Button, InputRightElement } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { LocationState } from "~/constants";
import { useLazyPromoCodesShowQuery } from "~/store/api";
import { fontSizes } from "~/utils/theme";
import { Values } from "./types";

interface Props {
  onApplied: () => void;
}

export const PromoCodeButton: FC<Props> = ({ onApplied }) => {
  const { t } = useTranslation();
  const {
    values: { promoCode },
    setFieldValue,
    setFieldError,
  } = useFormikContext<Values>();
  const [apiPromoCodesShow] = useLazyPromoCodesShowQuery();
  const location = useLocation();
  const state = location.state as LocationState;
  const plan = state.type;

  const handleClick = async () => {
    try {
      const data = await apiPromoCodesShow({
        promoCode,
        plan,
      }).unwrap();

      // Just to make TS happy. This should never happen.
      if (data.key !== "valid") return;

      setFieldValue("promoCodeId", data.id);
      setFieldValue("coupon", data.coupon);
      onApplied();
    } catch (e: any) {
      if (e.data.message) return setFieldError("promoCode", e.data.message);
      setFieldValue("promoCodeId", undefined);
      setFieldValue("coupon", undefined);

      setFieldError("promoCode", "Something went wrong. Please try again.");
    }
  };

  return (
    <InputRightElement pr={4}>
      <Button
        _hover={{
          bgColor: "transparent",
        }}
        bgColor="transparent"
        fontSize={fontSizes.sm}
        isDisabled={!promoCode}
        onClick={handleClick}
        variant="th-button-text"
      >
        {t("planPayment.promoCode.apply")}
      </Button>
    </InputRightElement>
  );
};
